import { DeliveryAppointmentAction } from '../actions/DeliveryAppointmentAction';
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const initState = {
    requestBody: {
        sectionId: "DeliveryAppointment",
        steps: [
            {
                sequence: "0",
                stepId: "DeliveryAppointment",
                fields: [
                    {
                        name: "Delivery Day",
                        value: ""
                    },
                    {
                        name: "Delivery Time",
                        value: ""
                    }
                ]
            }
        ]
    },
    getAppointmentsSlotsResponse: {}
}

const DeliveryAppointmentReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var DeliveryAppointmentValue = { ...state.requestBody.steps };

    switch (type) {
        case DeliveryAppointmentAction.RETRIEVE_APPOINTMENTS_SUCCESS:
            return { ...state, getAppointmentsSlotsResponse: payload };
        case DeliveryAppointmentAction.UPDATE_SELECTED_DATE:
            DeliveryAppointmentValue[0].fields[0].value = payload.day
            DeliveryAppointmentValue[0].fields[1].value = payload.time
            return state
        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, getAppointmentsSlotsResponse: {}, reserveAppointmentResponse: {} }

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'DeliveryAppointment')
            });
            if (section.length > 0) {
                for (let i = 0; i < DeliveryAppointmentValue[0].fields.length; i++) {
                    const AppointmnetDetailsField = section[0].steps[0].fields.filter((field: any) => { return (field.name === DeliveryAppointmentValue[0].fields[i].name) })[0];
                    DeliveryAppointmentValue[0].fields[i].value = AppointmnetDetailsField ? AppointmnetDetailsField.value : "";
                }
            }
            return state;

        default:
            return state;
    }
}

export default DeliveryAppointmentReducer;